var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'react-emotion';
import { css } from 'emotion';
export const buttonStyles = css `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  color: white;
  background-color: grey;
  border-color: grey;
  cursor: pointer;

  text-align: center;
  height: 54px;
  font-family: 'Source Sans Pro', sans-serif;
  width: 100%;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const BaseButton = styled('button') `
  ${buttonStyles};
  ${({ theme }) => theme.above.md} {
    max-width: 300px;
  }
`;
const BaseLink = styled('a') `
  ${buttonStyles};
  text-decoration: none;
  ${({ theme }) => theme.above.md} {
    max-width: 300px;
  }

  :hover {
    text-decoration: none;
  }
`;
const Button = (_a) => {
    var { icon, text, children, anchor = false } = _a, rest = __rest(_a, ["icon", "text", "children", "anchor"]);
    const Comp = anchor
        ? BaseLink
        : BaseButton;
    return (React.createElement(Comp, Object.assign({ type: "button" }, rest),
        icon ? [React.createElement(icon, { key: 'icon' }), ' '] : '',
        text,
        children));
};
export default Button;
//# sourceMappingURL=Button.js.map